module.exports = __webpack_public_path__ + "img/2025big10.a0b012d5.jpg";